import { createTranslations } from '@npco/common-utils-translations'

export const contactSimpleFormTranslations = createTranslations({
  titleBusiness: 'Add Business',
  titlePerson: 'Add Person',
  subheadingPersonalDetails: 'Personal Details',
  subheadingBusinessDetails: 'Business Details',
})
